<template>
  <span class="device-type-cell">
    <span
        v-if="showStatus"
        class="device-type-cell__dot"
        :class="online ? 'device-type-cell__dot--online' : 'device-type-cell__dot--offline'"
        :title="online ? $t('online') : $t('offline')"
    ></span>
    {{ name }}
  </span>
</template>

<script>
import { cameraStatus, isCameraOnline } from '../cameraStatus'

export default {
  name: 'DeviceTypeCell',

  props: {
    row: {
      type: Object,
      required: true,
    },
  },

  computed: {
    name() {
      return (this.row.device_type && this.row.device_type.name) || ''
    },
    showStatus() {
      return this.name === 'Câmera' && !!this.row.hikvision_device_id && cameraStatus.available === true
    },
    online() {
      return isCameraOnline(this.row.hikvision_device_id)
    },
  },
}
</script>

<style scoped>
.device-type-cell {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.device-type-cell__dot {
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 50%;
}

.device-type-cell__dot--online {
  background: #28c76f;
}

.device-type-cell__dot--offline {
  background: #d0d0d8;
}
</style>
